<template>
  <div class="cooperation-cases">
    <div class="section-title">
      <h2>{{ $t('about.cases') }}</h2>
    </div>
    <div class="cases-container">
      <div class="case-item" v-for="caseItem in caseList" :key="caseItem.id">
        <img
          :src="caseItem.iconUrl"
          :alt="caseItem.partnerName"
        />
        <div class="case-name">{{ caseItem.partnerName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'CooperationCases',
  data() {
    return {
      caseList: [],
      loading: false
    }
  },
  mounted() {
    this.fetchCases()
  },
  methods: {
    async fetchCases() {
      this.loading = true
      try {
        const response = await api.cooperationCase.getCooperationCaseList({
          page: 1,
          limit: 100
        })
        if (response.success) {
          this.caseList = response.data.list || []
        }
      } catch (error) {
        console.error('获取合作案例失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.cooperation-cases {
  padding: 60px 20px;
  background-color: #ffffff;
}

.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0;
  position: relative;
  display: inline-block;
}

/* .section-title h2::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #409EFF;
} */

.cases-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 30px;
  justify-items: center;
}

.case-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08); */
  width: 100%;
  max-width: 240px;
}

/* .case-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);
} */

.case-item img {
  width: 200px;
  height: 200px;
  margin-bottom: 15px;
  object-fit: contain;
}

.case-name {
  font-size: 1rem;
  color: #666;
  line-height: 1.4;
}

@media (max-width: 1300px) {
  .cases-container {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 25px;
  }
}

@media (max-width: 768px) {
  .cooperation-cases {
    padding: 40px 15px;
  }

  .section-title h2 {
    font-size: 24px;
  }

  .cases-container {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 20px;
  }

  .case-item {
    max-width: 200px;
    padding: 15px;
  }

  .case-item img {
    width: 160px;
    height: 160px;
  }

  .case-name {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .cases-container {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 15px;
  }

  .case-item {
    max-width: 160px;
    padding: 12px;
  }

  .case-item img {
    width: 130px;
    height: 130px;
    margin-bottom: 10px;
  }

  .case-name {
    font-size: 12px;
  }
}
</style>